import {Layout} from '@fantasmagames/slot/src/layout/Layout';
import {ViewTypes} from '@fantasmagames/slot/src/common/view/View';

export class PositionUtils {
	public static isEqual(pos1: SymbolPosition, pos2: SymbolPosition): boolean {
		if (!pos1 || !pos2) {
			return false;
		}

		return pos1.x === pos2.x && pos1.y === pos2.y;
	}
}

export interface SymbolPosition {
	x: number;
	y: number;
}

export interface Position extends SymbolPosition {
}

export interface Scale extends Position {
}

export interface Dimensions extends SymbolSizes {
	scale: Scale;
}

export interface Offset extends Position {
}

export interface SymbolSizes {
	width: number;
	height: number;
}

export interface ObjectSize extends SymbolSizes {
}

export interface Dimensions extends SymbolSizes {
	scale: Scale;
}

export interface ReelPositionsConfig {
	x: number;
	y: number;

	symsPositions: SymbolPosition[];
}

export class ReelConstants {
	public static readonly FIRST_VISIBLE_ROW: number = 2;
	public static readonly FIRST_VISIBLE_ROW_ON_STOP: number = 1;

	public static REELS_AMOUNT: number = 6;
	public static ROW_AMOUNT: number = 6;
	public static MAX_ROW_AMOUNT: number = 6;

	public static LINES: number = 0;
	public static BOTH_WAYS: boolean = false;

	public static DEFAULT_VIEW: ViewTypes = 0;
	protected static REELS_OFFSETS: Position[] = [];

	protected static SYMBOL_SLOT: SymbolSizes[] = [];
	protected static REELS: ReelPositionsConfig[][] = [];

	protected static REELS_CENTER: Position[] = [];

	public static setReelsAmount(reels: number): void {
		ReelConstants.REELS_AMOUNT = reels;
	}

	public static setRowAmount(rows: number): void {
		ReelConstants.ROW_AMOUNT = rows;
	}

	public static setMaxRowAmount(rows: number): void {
		ReelConstants.MAX_ROW_AMOUNT = rows;
	}

	public static addReelsConfig(config: ReelPositionsConfig, viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): void {
		ReelConstants.REELS[viewType].push(config);
	}

	public static recalculateNumbers(viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): void {
		ReelConstants.REELS_CENTER[viewType] = {
			x: ReelConstants.REELS_OFFSETS[viewType].x + (ReelConstants.SYMBOL_SLOT[viewType].width * ReelConstants.REELS_AMOUNT) / 2,
			y: ReelConstants.REELS_OFFSETS[viewType].y + (ReelConstants.SYMBOL_SLOT[viewType].height * ReelConstants.ROW_AMOUNT) / 2,
		};
	}

	public static initializeFromLayout(layout: Layout, viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): void {
		const reelPosition: Position = layout.getAbsolutePosition('REEL', viewType);
		const symbolSize: ObjectSize = layout.getSize('SYMBOL_01', viewType);
		ReelConstants.REELS_OFFSETS[viewType] = {x: reelPosition.x, y: reelPosition.y};
		ReelConstants.SYMBOL_SLOT[viewType] = {width: symbolSize.width, height: symbolSize.height};

		ReelConstants.recalculateNumbers();
	}

	public static getReelsOffsets(viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): SymbolPosition {
		return ReelConstants.REELS_OFFSETS[viewType];
	}

	public static getSymbolSlot(viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): SymbolSizes {
		return ReelConstants.SYMBOL_SLOT[viewType];
	}

	public static getReelsPositionConfig(viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): ReelPositionsConfig[] {
		return ReelConstants.REELS[viewType];
	}

	public static getReelsCenter(viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): SymbolPosition {
		return ReelConstants.REELS_CENTER[viewType];
	}

	public static getReels(viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): ReelPositionsConfig[] {
		return ReelConstants.REELS[viewType];
	}

	public static getSymbolPosition(position: SymbolPosition, viewType: ViewTypes = ReelConstants.DEFAULT_VIEW): Position {
		const positionOnScreen: Position = {
			x:
				ReelConstants.getReelsOffsets(viewType).x +
				ReelConstants.getSymbolSlot(viewType).width * position.x +
				ReelConstants.getSymbolSlot(viewType).width / 2,
			y:
				ReelConstants.getReelsOffsets(viewType).y +
				ReelConstants.getSymbolSlot(viewType).height * position.y +
				ReelConstants.getSymbolSlot(viewType).height / 2,
		};

		return positionOnScreen;
	}
}

export class AvalancheConstants {
	public static TIMER_BETWEEN_REELS_OUT: number = 45;
	public static TIMER_BETWEEN_SYMBOLS_OUT: number = 17;
	public static TIMER_BETWEEN_REELS_NEW: number = 100;
	public static TIMER_BETWEEN_SYMBOLS_NEW: number = 17;

	public static AVALANCHE_OUT_TIMER: number = 320;
	public static AVALANCHE_NEW_TIMER: number = 270;
	public static AVALANCHE_REPOSITION_TIMER: number = 450;
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/ReelConstants.ts